(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Layer = (function(superClass) {
    extend(Layer, superClass);

    Layer.prototype.setInitialDeps = function() {
      Layer.__super__.setInitialDeps.call(this);
      return this.syncDeps({
        'Stage': 'grower::viewmodels/prescription_map/Stage'
      });
    };

    function Layer(parent, data, deps) {
      var ref, ref1, ref10, ref11, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, stages;
      if (data == null) {
        data = {};
      }
      if (deps == null) {
        deps = {};
      }
      Layer.__super__.constructor.call(this);
      this.syncDeps(deps);
      this.ignore('total_acres');
      this.parent = parent;
      this.id = (ref = (ref1 = data.prescription_map) != null ? ref1.id : void 0) != null ? ref : null;
      this.layer_name = ko.observable((ref2 = (ref3 = data.layer) != null ? ref3.name : void 0) != null ? ref2 : null);
      this.layers_id = (ref4 = (ref5 = data.prescription_map) != null ? ref5.layers_id : void 0) != null ? ref4 : null;
      this.year = (ref6 = (ref7 = data.layer) != null ? ref7.year : void 0) != null ? ref6 : parent.handler.loadLayoutPostOptions.year;
      this.fields_id = (ref8 = (ref9 = data.layer) != null ? ref9.fields_id : void 0) != null ? ref8 : parent.handler.loadLayoutPostOptions.fields_id;
      this.base_layer = ko.observable((ref10 = (ref11 = data.prescription_map) != null ? ref11.base_layer : void 0) != null ? ref10 : null);

      /*
      This is a bit weird, it relies on the stages existing,
      but the stages are the ones who need this value, so they can
      calculate percent acreage.
      
      To make everything work correctly, we defer this calculation.
      It will run when the children first try to calculate their populations.
      
      See the Stage.percent_acres calculation to see how the rest
      of this is worked out
       */
      this.total_acres = ko.computed({
        read: (function(_this) {
          return function() {
            var i, len, ref12, t_acres, v;
            t_acres = 0;
            ref12 = _this.stages;
            for (i = 0, len = ref12.length; i < len; i++) {
              v = ref12[i];
              t_acres += parseFloat(v.field_soil_acres);
            }
            return t_acres.toFixed(1);
          };
        })(this),
        deferEvaluation: true
      });
      if (data.prescription_map_stages != null) {
        stages = $.map(data.prescription_map_stages, (function(_this) {
          return function(item) {
            return new (_this.getDep('Stage'))(_this, item);
          };
        })(this));
      } else {
        stages = [new (this.getDep('Stage'))(this)];
      }
      this.stages = stages;
    }

    return Layer;

  })(KoModel);

}).call(this);
